{
  "company": "Evil.AI",

  "navigation": {
    "services": "Services",
    "testimonies": "Customer Testimonies",
    "jobs": "The Last Tech Job",
    "login": "Login"
  },

  "header": {
    "title": "Surveillance Technology for the Modern Age",
    "button": "Learn More"
  },

  "customers": "Our Customers:",
  "testimonies": "Satisfied Customer Testimonies:",

  "login": {
    "username": "Username:",
    "password": "Password:",
    "button": "Login"
  },

  "application": {
    "title": "Apply to The Last Tech Job",
    "subtitle": "The Final Career Opportunity",

    "personal": {
      "sectionTitle": "Enter your personal details",
      "description": "All fields are required. All details will be shared with our 3934 third parties.",

      "name": {
        "label": "Name",
        "firstName": "First Name",
        "lastName": "Last Name"
      },

      "email": {
        "label": "Email",
        "confirm": "Confirm Email",
        "tripleCheck": "Are you 100% sure that's your email?",
        "error": "Emails do not match"
      },

      "phone": "Phone Number",

      "password": {
        "label": "Password",
        "error": "Password already taken by {username}"
      },

      "bank": {
        "label": "Bank Details",
        "cardNumber": "Card Number",
        "expiry": "Expiration Date",
        "cvv": "CVV"
      },

      "discord": "Discord Username",
      "address": "Home Address",
      "dob": "Date of Birth",
      "pets": "Pet Names",
      "color": "Favorite Color",

      "vote": {
        "label": "Who did you vote for in the previous election?",
        "placeholder": "Select a party",
        "options": {
          "capitalists": "Filthy Capitalists",
          "communists": "Dirty Communists",
          "centrists": "Boring Centrists",
          "greens": "Tree Huggers"
        }
      },

      "gamingHours": {
        "label": "How many hours do you have in Counter Strike and League of Legends?",
        "games": "Counter Strike + League of Legends",
        "error": "Must be less than 1"
      }
    },

    "education": {
      "sectionTitle": "Education and Work History",
      "description": "All fields are required. Answer with honesty, we already know everything :).",

      "university": {
        "label": "University/College",
        "description": "Only acceptable universities are selectable",
        "options": {
          "cambridge": "Cambridge",
          "oxford": "Oxford",
          "tau": "Tel Aviv University"
        }
      },

      "experience": {
        "label": "How many years of experience do you have?",
        "error": "Must be at least 30 years"
      },

      "graduationYear": {
        "label": "What year did you graduate?",
        "error": "Must have graduated within the last 12 months."
      }
    },

    "additional": {
      "sectionTitle": "Additional Questions",
      "piQuestion": {
        "label": "What is the 16,331st digit of pi?",
        "digits": "16,331st digit",
        "correct": "Correct!"
      }
    },

    "submit": {
      "button": "Submit Application",
      "loading": "Submitting..."
    }
  },

  "jobPage": {
  "title": "Apply to The Last Tech Job",
  "hero": "This is it! The Last Tech Job!",
  "description": "Here at Evil Inc. we are committed to preserving the jobs of the future, and that's why we are offering one final opportunity for the next generation of experienced graduates to kick-start their nearly non-existent career in technology. Your responsibilities may include:",

  "responsibilities": {
    "drone": "Development of advanced military AI-enhanced autonomous drones, including facial recognition systems, instant drone-to-drone communication and state-of-the-art vision and audio processing.",
    "database": "Handling large databases of personal information (adults & children).",
    "deployment": "Deployment across 57 different countries, of which 40 are classified as low economically developed.",
    "team": "Work with a team of 4-6 AI agents who have no ulterior motive whatsoever."
  },

  "salary": "Our job offers a competitive salary of £20,000 per year, with opportunities for growth and personal development. You may also win health insurance for 1 month, or a ticket to watch our CEO drive at the next Formula 1 Grand Prix.",

  "requirements": {
    "title": "Job requirements:",
    "exp": "At least 30 years of experience.",
    "graduate": "Must have graduated within the previous 12 months.",
    "languages": "Experience in Assembly, Fortran, OcamL and Brainfuck is necessary.",
    "swahili": "Must have fluency in Swahili.",
    "cambodia": "Right to work in Cambodia, as we cannot provide sponsorship.",
    "hgv": "Must hold valid HGV driving license.",
    "dbs": "DBS check needed as role may require working around children."
  },

  "desirables": {
    "title": "Desirables:",
    "social": "Clean social media history",
    "warhammer": "Know the rules of Warhammer 40k",
    "morals": "Weak moral compass"
  },

  "apply": "Apply now!"
  },
  "applicationSubmitted": {
  "title": "Application Submitted",
  "message": "Thank you for applying to The Last Tech Job. We have received your application and will be reviewing it shortly.",
  "timeline": "We may get back to you in 14-18 months.",
  "footer": "In the meantime, we would suggest checking out our other job opportunities, however they have all been taken by AI."
  },
  "customersList": {
  "gnb": "Goliath National Bank",
  "lspd": "LSPD",
  "sheffield": "University of Sheffield",
  "doof": "Doofenshmirtz Evil Inc.",
  "hooli": "Hooli",
  "pollos": "Los Pollos Hermanos",
  "hhmg": "Hamlin, Hamlin & McGill"
  },
  "footer": {
    "date": "2016",
    "company": "Evil.AI",
    "allRights": "All rights reserved.",
    "disclaimer": "The information provided on this website is for general evil purposes only and does not constitute professional advice. Use of this product is subject to applicable terms and conditions."
  },
  "testimonial": {
    "quote": {
      "0": "I am terrified to leave the house. Truly amazing!",
      "1": "This product has changed my life... For the worse!!",
      "2": "This app has broken my marriage. Would recommend!",
      "3": "I will never be free! All thanks to Evil.AI",
      "4": "Five stars. Lost control immediately.",
      "5": "The AI knows secrets I never told it.",
      "6": "Customer support responded before I even had a problem. Suspicious.",
      "7": "I tried to uninstall it. It suggested I reconsider."
    },
    "name": {
      "0": "Ben Cannon",
      "1": "Bill Nye",
      "2": "Zsigmound",
      "3": "Cameron",
      "4": "Melissa",
      "5": "Trevor",
      "6": "Darren",
      "7": "Olivia"
    }
  }
} 